import { Controller } from "@hotwired/stimulus";
import { fetchStream } from "../utils/turbo_utils";
import { modalElement } from "../utils/misc";

export default class extends Controller {
  static targets = ["loader", "container"];

  connect() {
    const modal = modalElement(this.element.id);

    modal.on("show.bs.modal", (e) => {
      const url = e.relatedTarget.dataset.url;

      this._loadModal(url);
    });

    modal.on("hide.bs.modal", () => {
      this._resetModal();
    });
  }

  _loadModal(url) {
    this._toggleElements();
    fetchStream(url).then(() => this._toggleElements());
  }

  _toggleElements() {
    this.loaderTarget.classList.toggle("hidden");
    this.containerTarget.classList.toggle("hidden");
  }

  _resetModal() {
    this.containerTarget.innerHTML = "";
  }
}
